import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

export enum AtsBreakpoints {
	Mobile = '(max-width: 959px)',
	Small = '(max-width: 599px)',
}

export interface ScreenSizes {
	small: boolean;
	mobile: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class AtsResponsiveService {
	public windowResize$ = fromEvent(window, 'resize').pipe(debounceTime(400));

	constructor(private breakpointObserver: BreakpointObserver) {}

	public breakpoints$: Observable<ScreenSizes> = this.breakpointObserver
		.observe([AtsBreakpoints.Small, AtsBreakpoints.Mobile])
		.pipe(
			map(result => ({
				small: result.breakpoints[AtsBreakpoints.Small],
				mobile: result.breakpoints[AtsBreakpoints.Mobile],
			}))
		);
}
